import BaseService from "./BaseService";
import {ROOT, ACCOUNT} from "./_base";

class BoRegistrationService extends BaseService {

    async initBoRegister() {
        const response = await this.getByUri(`${ROOT}/${ACCOUNT}/init-bo-register`);
        return response.data;
    }

    async confirmBoRegister(params) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/confirm-bo-register`, params);
        return response.data;
    }

    async saveBoRegister(params) {
        const response = await this.post(`${ROOT}/${ACCOUNT}/save-bo-register`, params);
        return response.data;
    }
}
export default BoRegistrationService;
